import navAttributes from "./nav.json";

export default {
  ...navAttributes,
};
